// extracted by mini-css-extract-plugin
var _1 = "_YZTU9";
export { _1 as "dialog" }
